var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ad-banner'),_c('ad-prototype'),_c('ad-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }